var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oil-sample-graph-bar"},[_c('Chart',{ref:"oilSampleGraphBar",attrs:{"options":_vm.options,"callback":_vm.createCustomLegendAndAddChartToData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }